import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { countScreensInMaintenance } from '@/services/maintenanceService';
import { useData } from '@/contexts/DataContext';
import { Loader2, MonitorSmartphone, Wrench } from 'lucide-react';

const MaintenanceSummary: React.FC = () => {
  const [screensInMaintenance, setScreensInMaintenance] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const { screens } = useData();

  useEffect(() => {
    const loadMaintenanceCount = async () => {
      try {
        const count = await countScreensInMaintenance();
        setScreensInMaintenance(count);
      } catch (error) {
        console.error('Error al cargar el conteo de pantallas en mantenimiento:', error);
      } finally {
        setLoading(false);
      }
    };

    loadMaintenanceCount();
  }, []);

  const totalScreens = screens.length;
  const operativeScreens = totalScreens - screensInMaintenance;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-2">
      {/* Tarjeta de Pantallas Operativas */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-base font-medium">
            Pantallas Operativas
          </CardTitle>
          <MonitorSmartphone className="h-6 w-6 text-green-500" />
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="flex items-center space-x-2">
              <Loader2 className="h-5 w-5 animate-spin" />
              <span className="text-base text-muted-foreground">Cargando...</span>
            </div>
          ) : (
            <>
              <div className="text-3xl font-bold">{operativeScreens}</div>
              <p className="text-sm text-muted-foreground">
                {Math.round((operativeScreens / totalScreens) * 100)}% del total de pantallas
              </p>
            </>
          )}
        </CardContent>
      </Card>

      {/* Tarjeta de Pantallas en Mantenimiento */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-base font-medium">
            Pantallas en Mantenimiento
          </CardTitle>
          <Wrench className="h-6 w-6 text-amber-500" />
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="flex items-center space-x-2">
              <Loader2 className="h-5 w-5 animate-spin" />
              <span className="text-base text-muted-foreground">Cargando...</span>
            </div>
          ) : (
            <>
              <div className="text-3xl font-bold">{screensInMaintenance}</div>
              <p className="text-sm text-muted-foreground">
                {Math.round((screensInMaintenance / totalScreens) * 100)}% del total de pantallas
              </p>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default MaintenanceSummary; 